import { Filter, ReferenceField, TextField, TextInput } from 'react-admin'

export const SFMSSearchFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
  </Filter>
)

export const ContentRefField = (props: any) => {
  const { record } = props

  return record?.content_type === 'custom_load' ? (
    <ReferenceField
      basePath="/custom-loads"
      record={props.record}
      source="id"
      reference="custom-loads"
      link="show"
    >
      <TextField source="id" />
    </ReferenceField>
  ) : (
    <ReferenceField basePath="/edi-loads" record={props.record} source="id" reference="edi-loads" link="show">
      <TextField source="id" />
    </ReferenceField>
  )
}
